import { Component, Input, EventEmitter, Output } from "@angular/core";
import { DataValueStyle } from "./dataValueStyle";
import { DataIcon } from "./dataIcon";

@Component({
    selector: 'dual-data',
    templateUrl: './dualData.component.html',
    standalone: false
})
export class DualDataComponent {
    public dataIcon = DataIcon;
    public dataValueStyle = DataValueStyle;

    @Input() public iconA: DataIcon = DataIcon.None;
    @Input() public valueA: number = 0;
    @Input() public valueAStyle: DataValueStyle = DataValueStyle.None;
    @Input() public subValueA: string;
    @Input() public footerA: string;
    @Input() public footerAStyle: DataValueStyle = DataValueStyle.None;
    @Output() public valueAClick: EventEmitter<Event> = new EventEmitter<Event>();
    @Input() public iconB: DataIcon = DataIcon.None;
    @Input() public valueB: number = 0;
    @Input() public valueBStyle: DataValueStyle = DataValueStyle.None;
    @Input() public subValueB: string;
    @Input() public footerB: string;
    @Input() public footerBStyle: DataValueStyle = DataValueStyle.None;
    @Output() public valueBClick: EventEmitter<Event> = new EventEmitter<Event>();

    public raiseValueAClick(event: Event) : void {
        if (this.valueAClick.observers.length > 0) {
            this.valueAClick.emit(event);
        }
    }

    public raiseValueBClick(event: Event): void {
        if (this.valueBClick.observers.length > 0) {
            this.valueBClick.emit(event);
        }
    }
}